import { Route, Routes } from 'react-router-dom'
import BookingPage from './pages/booking-page/BookingPage'
import ReschedulePage from './pages/reschedule-page/ReschedulePage'
import CancelPage from './pages/cancel-page/CancelPage'
import NotFoundPage from './pages/not-found-page/NotFoundPage'
import HomePage from './pages/home-page/HomePage'
import FeaturesPage from './pages/features-page/FeaturesPage'
import UseCasesPage from './pages/use-cases-page/UseCasesPage'

const AppRoutes = (): JSX.Element => (
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/features" element={<FeaturesPage />} />
    <Route path="/use-cases" element={<UseCasesPage />} />
    <Route path="/:agentUserId/:slug" element={<BookingPage />} />
    <Route path="/reschedule/:token" element={<ReschedulePage />} />
    <Route path="/cancel/:token" element={<CancelPage />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
)

export default AppRoutes
